const WHEEL_LOADER = {
  length: 6.45,
  bodyWidth: 2.45,
  wheelRadius: 0.68,
  tyreWidth: 0.42,
  axles: [
    { fitment: 'single', x: 2.15, halfTrack: 1.02 },
    { fitment: 'single', x: -2.05, halfTrack: 1.02 },
  ],
  chassisY: 1.08,
};

export { WHEEL_LOADER };
